export function createDeviceHandler({
  getCameraId,
  getMicrophoneId,
  getCameraList
}) {
  const compareDevices = async () => {
    const availableDevices = await navigator.mediaDevices.enumerateDevices();
    const availableVideoDevices = availableDevices.filter(
      (device) => device.kind === "videoinput"
    );
    const availableAudioDevices = availableDevices.filter(
      (device) => device.kind === "audioinput"
    );

    const cameraId = getCameraId();
    const microphoneId = getMicrophoneId();
    const cameraList = getCameraList();
    const devicesIds = availableDevices.map((device) => device.deviceId);
    const availableDeviceIds = devicesIds.filter(
      (id) => id === cameraId || id === microphoneId
    );
    if (
      (!cameraId && availableVideoDevices.length > 0) ||
      (!microphoneId && availableAudioDevices.length > 0) ||
      (cameraId && !availableDeviceIds.includes(cameraId)) ||
      (microphoneId && !availableDeviceIds.includes(microphoneId)) ||
      availableVideoDevices.length > (cameraList?.length || 0)
    ) {
      window.deviceChangeDetected = true;
      window.location.reload();
    }
  };
  navigator.mediaDevices.addEventListener("devicechange", compareDevices);

  return () =>
    navigator.mediaDevices.removeEventListener("devicechange", compareDevices);
}

export async function getCameraAndMicrophoneInfo() {
  try {
    const deviceList = await navigator.mediaDevices.enumerateDevices();

    const videoDevices = deviceList.filter(
      (device) => device.kind === "videoinput"
    );
    const audioDevices = deviceList.filter(
      (device) => device.kind === "audioinput"
    );
    const audioOuputDevices = deviceList.filter(
      (device) => device.kind === "audiooutput"
    );

    return {
      cameraId: videoDevices[0].deviceId,
      microphoneId: audioDevices[0].deviceId,
      audioOutputs: audioOuputDevices,
      cameraList: videoDevices
    };
  } catch (err) {
    console.log("Couldn't get device list from navigator");
  }
}
